import styled, { keyframes } from "styled-components";

const texClip = keyframes`
 to {
    background-position: 200% center;
  }
`;

export const HomeHeroMainDiv = styled.div``;

export const HomeHeroDiv = styled.div`
  max-width: 966px;
  border-left: 1px solid rgb(31, 31, 31);
  border-top: 1px solid rgb(31, 31, 31);
  border-bottom: 1px solid rgb(31, 31, 31);
  margin: 0 auto;

  > h1 {
    text-align: center;
    text-transform: uppercase;
    background: rgb(12, 12, 12);
    backdrop-filter: blur(6px);
    border-bottom: 2px solid rgba(63, 122, 144, 0.53);
    border-right: 2px solid rgba(63, 122, 144, 0.53);
    padding: 36px 0 36px;
    margin: 0;
  }

  .flex {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .hero_header {
    lign-items: center;
    display: flex;
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 16px;
    height: min-content;
    justify-content: center;
    overflow: hidden;
    padding: 48px 48px 0;
    position: relative;
    width: 100%;
  }
  .small_text {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: rgb(161, 161, 161);
  }
  svg {
    color: rgb(161, 161, 161);
  }
  .hero {
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
    border-right: 1px solid rgb(31, 31, 31);

    min-height: 455px;

    box-sizing: border-box;
    min-width: 300px;
    .center {
      text-align: left;
    }
    > svg {
      width: 50px;
      height: 50px;
      margin: 40px auto;
    }
    > div {
      > h1 {
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0px;
      }
      > p {
        margin: 0;
        font-size: 1rem;
        line-height: 1.4em;
        color: rgb(161, 161, 161);
      }
    }
    .section {
      flex: 1;
    }
  }
  > section {
    flex-wrap: wrap;
    display: flex;
  }
  .video_hero {
    height: 300px;
    width: 100%;
  }
  .video {
    width: 99%;
    height: 100%;
    object-fit: cover;
  }
`;

export const HomeHero = styled.div`
  .homehero-container {
    height: 100vh;
    margin: 20px auto 48px;
    max-width: 966px;
    border-bottom: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    overflow: hidden;

    position: relative;

    align-content: center;
    align-items: center;
    display: flex;
    flex: none;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
    justify-content: center;
    overflow: hidden;
    padding: 57px 0 160px;
    width: 100%;
  }

  .new_modal {
    background-color: #171717fe;
    padding: 8px 16px;
    width: fit-content;
    border-radius: 20px;
    font-size: 18px;
    margin: 0 auto;
    box-shadow: inset rgba(251, 251, 250, 0.1) 0px 0px 0px 1px;
  }

  color: rgba(243, 243, 243, 1);
  > div {
    flex: 1;

    width: 100%;
  }

  .header {
    font-size: 56px;
    margin: 0;
    line-height: 1.2em;
    text-align: center;
    text-transform: uppercase;
    font-weight: 900;

    animation: ${texClip} 7s linear infinite;
  }
  .hero-header {
    align-content: center;
    align-items: center;
    display: flex;
    flex: 1 0 0px;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 36px;
    height: min-content;
    justify-content: flex-start;
    max-width: 706.5px;
    overflow: visible;
    padding: 0;
    position: relative;
    width: 1px;
  }

  .text {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    margin: 12px auto;
    max-width: 480px;
  }
  .button-flex {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .button {
    margin: 0 auto;
    width: fit-content;
    border-radius: 50px;
    > button {
      border-radius: 50px;
    }
  }
  @media (max-width: 1200px) {
    .homehero-container {
      height: min-content;
      padding-top: 150px;
    }
  }

  @media (max-width: 1100px) {
    .header {
      font-size: 40px;
      // color: red;
      //border: 1px solid yellow;
      line-height: 1.2em;
    }
  }

  @media (max-width: 809px) {
    .hero-header {
      padding: 0 24px;
    }
  }
  @media (max-width: 750px) {
    .header {
      margin: 0;
      line-height: 1.2em;
    }
  }
  @media (max-width: 450px) {
    text-align: center;
    .homehero-container {
      height: min-content;
      padding-bottom: 50px;
    }
    .header {
      font-size: 28px;
    }
    .text {
      font-size: 16px;
    }
  }
`;

export const HomeCarouselDiv = styled.div`
  max-width: 966px;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 40px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 48px;
  width: 100%;
  border-left: 1px solid #1f1f1f;
  border-right: 1px solid #1f1f1f;
  margin: 0 auto;
  > div {
    position: relative;
  }
  .play {
    background-color: #000000ad;
    opacity: 1;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    z-index: 1;
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 10px;
    height: min-content;
    justify-content: center;
    overflow: hidden;
    padding: 30px 54px;
    width: min-content;
  }
  @media (max-width: 450px) {
    padding: 10px;

  }
`;
